// app/javascript/packs/application.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import CardList from '../components/CardList';

// Support component names relative to this directory:
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);

// Show the loading screen by default when the script loads
// This ensures it shows during initial page load
const loadingScreen = document.getElementById("loading-screen");
if (loadingScreen) {
    loadingScreen.style.display = "flex";
}

document.addEventListener("DOMContentLoaded", () => {
    // Helper functions for loading screen
    window.showLoading = () => {
        if (loadingScreen) {
            loadingScreen.style.display = "flex";
            loadingScreen.classList.add('visible');
        }
    };
    
    window.hideLoading = () => {
        if (loadingScreen) {
            loadingScreen.style.display = "none";
            loadingScreen.classList.remove('visible');
        }
    };
    
    // Hide loading screen when page has finished loading
    window.addEventListener('load', () => {
        hideLoading();
    });
    
    // Show loading screen when navigating away from the page
    window.addEventListener('beforeunload', () => {
        showLoading();
    });
    
    // Handle normal link clicks (standard navigation)
    document.addEventListener('click', (event) => {
        // Check if the clicked element is a link leading to a page navigation
        const link = event.target.closest('a');
        if (link && 
            link.href && 
            !link.href.startsWith('javascript:') && 
            !link.href.includes('#') && 
            link.target !== '_blank' &&
            !link.hasAttribute('data-remote') &&
            !event.metaKey && // Exclude cmd+click (opens new tab)
            !event.ctrlKey) { // Exclude ctrl+click (opens new tab on Windows)
            showLoading();
        }
    });
    
    // Handle form submissions (for traditional form submissions)
    document.addEventListener('submit', (event) => {
        const form = event.target;
        // Only show loading for regular form submissions (not AJAX/remote forms)
        if (!form.hasAttribute('data-remote')) {
            showLoading();
        }
    });
    
    // Turbolinks support (if using Turbolinks)
    if (typeof Turbolinks !== 'undefined') {
        document.addEventListener("turbolinks:click", showLoading);
        document.addEventListener("turbolinks:before-visit", showLoading);
        document.addEventListener("turbolinks:load", hideLoading);
    }
    
    // Turbo support (if using Hotwire/Turbo)
    if (typeof Turbo !== 'undefined') {
        document.addEventListener("turbo:click", showLoading);
        document.addEventListener("turbo:before-visit", showLoading);
        document.addEventListener("turbo:load", hideLoading);
        document.addEventListener("turbo:submit-start", showLoading);
        document.addEventListener("turbo:submit-end", hideLoading);
    }
    
    // Rails UJS remote forms
    document.addEventListener("ajax:before", showLoading);
    document.addEventListener("ajax:complete", hideLoading);
    document.addEventListener("ajax:error", hideLoading);
    
    // Manual test function
    window.testLoadingScreen = () => {
        showLoading();
        console.log("Testing loading screen - will hide in 3 seconds");
        setTimeout(hideLoading, 3000);
    };
    
    if (!loadingScreen) {
        console.warn("Loading screen element not found in the DOM");
    }
});

// Global function to initialize the diagram builder
const diagramBuilderRoots = new WeakMap();
let diagramBuilderInstanceId = 0;

window.initDiagramBuilder = function(containerId, initialCards = []) {
  // Check if dependencies are loaded
  try {
    const container = document.getElementById(containerId);
    if (container) {
      let root = diagramBuilderRoots.get(container);
      if (!root) {
        root = ReactDOM.createRoot(container);
        diagramBuilderRoots.set(container, root);
      }

      root.render(
        <React.StrictMode>
          <CardList key={diagramBuilderInstanceId++} initialCards={initialCards} />
        </React.StrictMode>
      );
    } else {
      console.error(`Container #${containerId} not found for diagram builder`);
    }
  } catch (error) {
    console.error("Failed to initialize diagram builder:", error);
  }
};